import type { ReactNode } from 'react';
import '../WoodButton.css';
import './Button.css';

type ButtonVariant = 'primary' | 'secondary' | 'ghost';
type ButtonSize = 'wide' | 'wide-sm' | 'auto' | 'square' | 'circle' | 'custom';

interface ButtonProps {
  children: ReactNode;
  onClick?: () => void;
  variant?: ButtonVariant;
  size?: ButtonSize;
  className?: string;
  disabled?: boolean;
  'aria-label'?: string;
  'aria-pressed'?: boolean;
}

const SIZE_CLASS: Record<ButtonSize, string> = {
  wide: 'push-wide',
  'wide-sm': 'push-wide-sm',
  auto: 'push-auto',
  square: 'push-square',
  circle: 'push-circle',
  custom: '',
};

const VARIANT_CLASS: Record<ButtonVariant, string> = {
  primary: '',
  secondary: 'btn-secondary',
  ghost: 'btn-ghost',
};

export function Button({
  children,
  onClick,
  variant = 'primary',
  size = 'wide',
  className,
  disabled,
  'aria-label': ariaLabel,
  'aria-pressed': ariaPressed,
}: ButtonProps) {
  return (
    <button
      className={`pushable ${SIZE_CLASS[size]} ${VARIANT_CLASS[variant]} ${className ?? ''}`.trim()}
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
      aria-pressed={ariaPressed}
    >
      <span className="shadow" />
      <span className="edge" />
      <span className="front">{children}</span>
    </button>
  );
}
